module.exports = __webpack_public_path__ + "img/imagen2.737c88cb.png";